import { List, ListItem, ListItemText, IconButton, AppBar, Toolbar, Typography, Button, Box, ListItemIcon, useMediaQuery, useTheme, SwipeableDrawer, Grid, Tooltip } from '@mui/material';
import {  PeopleAlt as PeopleAltIcon, Checklist, Menu as MenuIcon, Groups, AccessTime } from '@mui/icons-material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import { UserType } from '../../types/dataTypes';
import UserMenu from './UserMenu';
import { useIsAuthenticated } from "@azure/msal-react";
import GlobalSearchBar from './GlobalSearchBar';

type ToolbarNavigationProps = {
  user: UserType,
  userRoles?: string[],
}

// Projects and Timesheet (project database) are for INT-EE only and still work in progress.
const PROJECT_DB_ROLES = ['INTEE', 'AdminINTEE'];

function WipTag() {
  return (
    <Tooltip title="Work in progress - feedback welcome">
      <Box component="span" sx={{
        marginLeft: 0.75, paddingX: 0.6, paddingY: '1px', borderRadius: '4px', fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
        lineHeight: 1.4, color: '#5c4000', backgroundColor: '#fac775', verticalAlign: 'middle',
      }}>
        WIP
      </Box>
    </Tooltip>
  );
}

function ToolbarNavigation({ user, userRoles = [] }: ToolbarNavigationProps) {
  const hasProjectDb = userRoles.some((role) => PROJECT_DB_ROLES.includes(role));
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {['Experts', 'References', 'Projects', 'Timesheet'].filter((text) => hasProjectDb || (text !== 'Projects' && text !== 'Timesheet')).map((text) => (
          <ListItem button key={text} onClick={() => navigate(`/${text.toLowerCase()}`)}>
            <ListItemIcon>{text === 'Experts' ? <PeopleAltIcon /> : text === 'References' ? <ListAltIcon /> : text === 'Projects' ? <Checklist /> : <AccessTime />}</ListItemIcon>
            <ListItemText primary={<>{text}{(text === 'Projects' || text === 'Timesheet') && <WipTag />}</>} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          {isMobile ? (
            <>
            <Grid container justifyContent="space-between">
              <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                <MenuIcon />
              </IconButton>
              <SwipeableDrawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
              >
                {list()}
              </SwipeableDrawer>
              <Button onClick={() => navigate('/')}>
                <img src={theme.logo} alt="Logo" style={{ width: '70px', marginRight: '30px' }} />
              </Button>
              <UserMenu user={user} />
              </Grid>
            </>
          ) : (
            <>
              <Button onClick={() => navigate('/')}>
                <img src={theme.logo} alt="Logo" style={{ width: '70px', marginRight: '30px' }} />
              </Button>
              {isAuthenticated ? (
                <>
                  <Box
                    sx={{ borderBottom: location.pathname === '/experts' ? '2px solid white' : 'none', display: 'inline-flex', alignItems: 'center', marginRight: 2 }}
                  >
                    <Button onClick={() => navigate('/experts')} startIcon={<PeopleAltIcon style={{ fontSize: '30', color:'white' }} />}>
                      <Typography variant="body1" color="white">Experts</Typography>
                    </Button>
                  </Box>
                  <Box
                    sx={{ borderBottom: location.pathname === '/references' ? '2px solid white' : 'none', display: 'inline-flex', alignItems: 'center', marginRight: 2  }}
                  >
                    <Button onClick={() => navigate('/references')} startIcon={<ListAltIcon style={{ fontSize: '30', color:'white'  }} />}>
                      <Typography variant="body1" color="white">References</Typography>
                    </Button>
                  </Box>
                         <Box
                    sx={{ borderBottom: location.pathname === '/partners' ? '2px solid white' : 'none', display: 'inline-flex', alignItems: 'center', marginRight: 2 }}
                  >
                  <Button onClick={() => navigate('/partners')} startIcon={<Groups style={{ fontSize: '30', color:'white' }} />}>
                      <Typography variant="body1" color="white">Partners</Typography>
                    </Button>
                  </Box>
                  {hasProjectDb && (
                    <>
                      <Box
                        sx={{ borderBottom: location.pathname.startsWith('/projects') ? '2px solid white' : 'none', display: 'inline-flex', alignItems: 'center', marginRight: 2 }}
                      >
                        <Button onClick={() => navigate('/projects')} startIcon={<Checklist style={{ fontSize: '30', color: 'white' }} />}>
                          <Typography variant="body1" color="white">Projects</Typography>
                          <WipTag />
                        </Button>
                      </Box>
                      <Box
                        sx={{ borderBottom: location.pathname === '/timesheet' ? '2px solid white' : 'none', display: 'inline-flex', alignItems: 'center', marginRight: 2 }}
                      >
                        <Button onClick={() => navigate('/timesheet')} startIcon={<AccessTime style={{ fontSize: '30', color: 'white' }} />}>
                          <Typography variant="body1" color="white">Timesheet</Typography>
                          <WipTag />
                        </Button>
                      </Box>
                    </>
                  )}
                </>
              ) : null}
              <Box sx={{ flexGrow: 1 }} />
              {isAuthenticated ? <GlobalSearchBar /> : null}
              <UserMenu user={user} />
            </>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
}

export default ToolbarNavigation;